module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/background-shooting.ad1f7934.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/background-shooting.png
// module id = 2828
// module chunks = 11